import React from 'react'
import MoreCoinsApp from '../MoreCoinsApp';

const MoreCoins = () => {
  return (
    <>
    <div>
         <MoreCoinsApp/>
         
    </div>
    
    
    </>
  )
}

export default MoreCoins
